import React, { Component } from "react";
import { ModuleAccordionGroup } from '@loanbossinc/component-library';
import { AccordionSection } from "component-lib/AccordionSection";
import { rows } from './section-property-disposition-rows';
import { PROPERTY_SECTION_KEYS } from '../property.constants';

export class PropertyDisposition extends Component {
  addDispositionInformation = {
    key: 'add-disposition-information'
    , buttonLabel: 'Add Disposition Information'
    , isButton: true
    , isTitleGroup: false
    , showEditButton: true
    , onClick: () => this.props.history.push(`/properties/${this.props.propertyId}/edit/${PROPERTY_SECTION_KEYS.PROPERTY_DISPOSITION}`)
  }

  getDispositionGroup = () => {
    const { data, propertyId, history, isSold, enableEditButton } = this.props;
    if (!isSold) return this.addDispositionInformation;

    return {
      title: 'Property Disposition'
      , key: PROPERTY_SECTION_KEYS.PROPERTY_DISPOSITION
      , isExpandable: true
      , isTitleGroup: false
      , buttonLabel: 'Edit Details'
      , showEditButton: enableEditButton
      , onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.PROPERTY_DISPOSITION}`)
      , sections: [
        <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />
      ]
    }
  }

  render() {
    const { data, isSold, ...other } = this.props;
    if (!data) return null;

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: 'Disposition'
            , key: 'disposition'
            , isTitleGroup: true
          }
          , this.getDispositionGroup()
        ]}
      />
    );
  }
}
